import { jsx as r } from "react/jsx-runtime";
import s from "classnames";
import d from "../../utils/colors.js";
import { a as h } from "../../styled-qu50FBLM.mjs";
import { Svg as c, GElement as e, Path as p } from "./Elements.js";
const v = ({
  className: o = "",
  fill: L = d.brown,
  viewBox: l = "0 0 15 15",
  width: n = 15,
  height: i = 15,
  d: a = "M308.179463,5 L314,5 L314,10.8205371 L312.320982,10.8205371 L312.320982,7.85201873 L304.157112,16.0167783 L302.985,14.8455564 L311.148871,6.67990751 L308.179463,6.67990751 L308.179463,5 Z M312.320982,18.3218711 L312.320982,12.501334 L314,12.501334 L314,18.3218711 C314,18.7647477 313.830142,19.155155 313.493093,19.4939823 C313.154266,19.8328096 312.763858,20.0026679 312.320982,20.0026679 L300.679018,20.0026679 C300.211241,20.0026679 299.813719,19.8328096 299.488231,19.4939823 C299.161855,19.155155 299,18.7647477 299,18.3218711 L299,6.67990751 C299,6.23703089 299.161855,5.84662358 299.488231,5.50779629 C299.813719,5.16896899 300.211241,5 300.679018,5 L306.499555,5 L306.499555,6.67990751 L300.679018,6.67990751 L300.679018,18.3218711 L312.320982,18.3218711 Z",
  $transition: m = "fill 0.1s ease-in-out",
  $cssHelper: f = h,
  focusable: t
}) => /* @__PURE__ */ r(
  c,
  {
    className: s({ [o]: !!o }),
    viewBox: l,
    width: n,
    height: i,
    $cssHelper: f,
    focusable: !!t,
    "aria-hidden": !t,
    children: /* @__PURE__ */ r(e, { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ r(e, { transform: "translate(-299.000000, -5.000000)", fill: L, children: /* @__PURE__ */ r(e, { children: /* @__PURE__ */ r(p, { d: a, $transition: m }) }) }) })
  }
);
export {
  v as default
};
